import React, { Fragment, useEffect, useState } from "react";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";
import { Table, Row, Col, Tooltip, Button, Badge, Card, CardHeader, CardBody } from "reactstrap";
import { IColumnModel } from "models/IColumnModel";
import { formatTableCell } from "components/constants/dsmConstants";
import { CustomButton } from "./CustomButton";
import { Link } from "react-router-dom";
import { currencyByCountry } from "helpers/Helper";
import Paginate from "components/Common/Paginate";
import { HelperConstant } from "../../helpers/HelperConstant";
import JobListGlobalFilter from "components/Common/GlobalSearchFilter";
import { DefaultColumnFilter, Filter } from "components/Common/filters";
import { CustomTextBox } from "components/shared/CustomTextBox";
import { CustomCheckBox } from "./CustomCheckBox";
import { Handler } from "leaflet";

interface filter {
  preGlobalFilteredRows: any;
  globalFilter?: any;
  setGlobalFilter: any;
  isJobListGlobalFilter: any;
  searchHandler: any
}

interface CustomDataTableProps {
  columns: Array<IColumnModel>;
  data: any;
  isGlobalFilter?: any;
  customPageSize: any;
  isJobListGlobalFilter?: any;
  isPagination?: any,
  selectedPage?: any,
  perPageData?: number,
  searchHandler?: any
  isActionEdit: boolean,
  isActionDelete: boolean,
  editHandler: any,
  shareHandler?: any,
  canShowButton1: boolean,
  canShowButton2: boolean,
  deleteHandler: any,
  createHandler: any,
  rowsPerPage?: any,
  currentPage?: any,
  setCurrentPage?: any,
  offsetStart?: any,
  setOffsetStart?: any
  path: string,
  /** @param {any} isSelect will give access to select the data */
  isSelect?: any,
  /** @param {any} onCheckboxChange is a callback function to send the selected id value */
  onCheckboxChange?: any,
  /** @param {any} isView is defines `it's view only or not*/
  /** @param {any} isView is defines `it's view only or not*/
  canView?: any,
  /** @param {any} isEdit defines it has only edit in actions */
  canEdit?: any,
  canImportView?: any,
  onColumnSortChange?: any,
  firstBtnName: string,
  secondBtnName?: string,
  routeHandler?: any,
  btnToolTip?: any,
  isNeedToolTip?: boolean
  specialGrid?: boolean,
  pageSize?: number,
  sortOrder?: any,
  recordsCount?: any,
  rowName?: any,
  linkBtnhandler?: any
}

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  isJobListGlobalFilter,
  searchHandler
}: filter) {
  const count: any = preGlobalFilteredRows.length;

  const [value, setValue] = React.useState(globalFilter);

  const onChange = useAsyncDebounce((value: any) => {
    searchHandler(value || undefined);
  }, 1000);

  return (
    <React.Fragment>
      <Col xxl={6} lg={12}>
        <input type="search" className="form-control" id="search-bar-0" value={value || ""} placeholder={"Search"} onChange={e => { setValue(e.target.value); onChange(e.target.value) }} />
      </Col>
    </React.Fragment>
  );
}
const CustomDataTable = ({
  columns,
  data,
  path,
  isGlobalFilter,
  isJobListGlobalFilter,
  isPagination,
  canShowButton1,
  canShowButton2,
  selectedPage,
  perPageData,
  searchHandler,
  isActionEdit,
  isActionDelete,
  deleteHandler,
  createHandler,
  editHandler,
  shareHandler,
  isSelect,
  canView,
  canImportView,
  canEdit,
  onCheckboxChange,
  onColumnSortChange,
  firstBtnName,
  secondBtnName,
  routeHandler,
  btnToolTip,
  specialGrid,
  pageSize,
  sortOrder,
  isNeedToolTip,
  recordsCount, rowName, linkBtnhandler, currentPage, customPageSize, offsetStart, rowsPerPage, setCurrentPage, setOffsetStart }: CustomDataTableProps) => {
  // const selectedId: number[] = [];
  // const [checkedIds, setCheckedIds] = useState<number[]>([]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    preGlobalFilteredRows,
    setGlobalFilter,
    state,
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: pageSize,
        // sortBy: [
        //   {
        //     desc: false,
        //   },
        // ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const handleColumnSort = (column: any) => {
    if (column.isSortable) {
      const sortOrder = column.sortDescFirst == false ? "asc" : "desc";
      column.sortDescFirst = !column.sortDescFirst;
      onColumnSortChange(column.id, sortOrder);
    }
  };

  const renderSortingIcon = (column: any) => {
    if (column.isSorted) {
      return column.isSortedDesc ? (
        <i className="fa fa-caret-down" />
      ) : (
        <i className="fa fa-caret-up" />
      );
    }
    return null;
  };
  const [isToolTip, setIsToolTip] = useState<boolean>(false);
  const [clickCounts, setClickCounts] = useState({});
  const [selectedIds, setSelectedIds] = useState([]) as any;
  let checkIds: number[] = []
  let unCheckIds: number[] = []
  const handleCheckboxChange = (event, id) => {
    const isChecked = event.target.checked;
    const currentClickCount = clickCounts[id] || 0;
    const newClickCount = currentClickCount === 0 ? 1 : 0;
    setClickCounts({
      ...clickCounts,
      [id]: newClickCount,
    });

    if (isChecked) {
      setSelectedIds([...selectedIds, id]);
      checkIds.push(id);
    } else {
      unCheckIds.push(id)
      checkIds = checkIds.filter((checkId) => checkId !== id);
      setSelectedIds(selectedIds.filter((selectedIds) => selectedIds !== id));
    }
    onCheckboxChange(checkIds, unCheckIds);
  };

  const checkIfChecked = (id) => {
    const clickCount = clickCounts[id] || 0;
    return clickCount === 0;
  };

  useEffect(() => {
    setSelectedIds([]);
    checkIds.length = 0
  }, []);

  return (
    <Fragment>
      <Row className="mb-3">
        <Col xl={8} lg={8} md={6}>
          {isGlobalFilter && (
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={state.globalFilter}
              setGlobalFilter={setGlobalFilter}
              isJobListGlobalFilter={isJobListGlobalFilter} searchHandler={searchHandler}
            />
          )}
        </Col>
        <Col xl={4} lg={4} md={6}>
          {canShowButton2 &&
            <div style={{ float: 'right', position: 'relative', top: '-20%' }} >
              <CustomButton
                type="Button"
                btnClassName="ms-1 btn-info"
                iconClasssName={undefined}
                name={secondBtnName}
                onClick={() => createHandler()}
                style={{}}>
              </CustomButton>
            </div>
          }
          {canShowButton1 &&
            <>
              <div style={{ float: 'right', position: 'relative' }} >
                <CustomButton
                  id='tableBtnToolTip'
                  type="Button"
                  btnClassName=" mx-3 mt-1 btn-success"
                  iconClasssName={undefined}
                  name={firstBtnName}
                  onClick={() => routeHandler()}
                  style={{}}>
                </CustomButton>
              </div>
              {isNeedToolTip ?
                <Tooltip
                  placement='top'
                  isOpen={isToolTip}
                  target="tableBtnToolTip"
                  toggle={() => {
                    setIsToolTip(!isToolTip);
                  }}
                  className='bg-light'
                >
                  <small>{btnToolTip}</small>
                </Tooltip> : null}
            </>
          }
        </Col>
      </Row>
      {data.length > 0 ?
        <>
          <div className="table-responsive">
            <Table  {...getTableProps()} responsive className="dofy-admin-font-small">
              {headerGroups.map((headerGroup: any) => (
                <>
                  <tbody  {...getTableBodyProps()} className="table-info" style={{ position: "sticky" }}>
                    <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()} style={{ border: "1px solid #ced4da", textAlign: specialGrid ? "center" : "unset" }}>
                      {headerGroup.headers.map((column: any) => {
                        const width = column.width;
                        if (
                          width === 0 ||
                          width === "0" ||
                          width === "0px" ||
                          width === "0%" ||
                          width === "0.0px"
                        ) {
                          return null;
                        }
                        return (
                          <th key={column.id} className={`${column.isSortable ? (column.isSorted ? "sorting" : "sorting") : ""}`} style={{ width: column.width, whiteSpace: "nowrap" }} onClick={() => handleColumnSort(column)}>
                            <div {...column.isSortable && { ...column.getSortByToggleProps() }}>
                              {column.displayInList === false || column.datatype === "checkBox" ? null : column.render("Header")}
                              {renderSortingIcon(column)}
                            </div>
                            <Filter column={column} />
                          </th>);
                      })}

                      {!shareHandler ? (
                        <>
                          {isActionEdit && <th>Edit</th>}
                          {isActionDelete && <th>Delete</th>}
                          {canView && <th>Actions</th>}
                          {canImportView && <th>Actions</th>}
                          {canEdit && <th>Actions</th>}
                        </>
                      ) : (
                        shareHandler && <th >Actions</th>
                      )}



                    </tr>
                  </tbody>
                  <tbody {...getTableBodyProps()} style={{ border: "1px solid #ced4da", textAlign: specialGrid ? "center" : "unset", whiteSpace: "nowrap" }} >
                    {page.map((row: any) => {
                      prepareRow(row);
                      return (
                        <Fragment key={row.getRowProps().key}>
                          {specialGrid ?
                            <tr>
                              {row.cells.filter((cell: any) => {
                                const width = cell.column.width;
                                if (!width) return true;
                                if (typeof width === "string" && (width === "0px" || width === "0%")) return false;
                                if (typeof width === "number" && width === 0) return false;

                                return true;
                              }).map((cell: any) => {
                                return (
                                  <>
                                    <td key={cell.id} {...cell.getCellProps()} style={{ width: cell.column.width && cell.column.width !== 0 ? cell.column.width : "auto", minWidth: 0, }} className="text-center">
                                      {
                                        (cell.column.datatype == "special" && cell.column.Header == "Variants") ?
                                          <React.Fragment>
                                            <Row>
                                              {cell.row.original.Variants.map((val, i) => (
                                                <Col xl="4" lg="6" md="6" sm="12" key={i} className="text-center">
                                                  <Card className="py-2 px-1 shadow-sm" style={{ width: '120px' }}>
                                                    <h6>{val.Name}</h6>
                                                    <h5>
                                                      <Badge color="danger">
                                                        Min : {currencyByCountry(val.MinimumValue)}
                                                      </Badge>
                                                    </h5>
                                                    <h5>
                                                      <Badge className="mt-2" color="success">
                                                        Max : {currencyByCountry(val.MaximumValue)}
                                                      </Badge>
                                                    </h5>
                                                  </Card>
                                                </Col>
                                              ))}
                                            </Row>
                                          </React.Fragment>
                                          :
                                          (cell.column.datatype == "special" && cell.column.Header == "Product Category") ?
                                            <React.Fragment>
                                              {cell.row.original.Variants[0].ProductCategoryName}
                                            </React.Fragment>
                                            :
                                            (cell.column.datatype == "special" && cell.column.Header == "Threshold Category") ?
                                              <React.Fragment>
                                                {cell.row.original.Variants[0].ThresholdCategoryName}
                                              </React.Fragment>
                                              :
                                              cell.value}
                                    </td>
                                  </>
                                );
                              })}
                              {isActionEdit ?
                                <td style={{ width: "5%" }}>
                                  <i className="fa fa-edit" style={{ cursor: "pointer" }} onClick={() => editHandler(row.original)}></i>&nbsp;&nbsp;&nbsp;
                                  {/* <i className="fa fa-trash" style={{ cursor: "pointer" }} onClick={() => deleteHandler(row.original)}></i> */}
                                </td>
                                :
                                null
                              }
                              {isActionDelete ?
                                <td style={{ width: "5%" }}>
                                  {/* <i className="fa fa-edit" style={{ cursor: "pointer" }} onClick={() => editHandler(row.original)}></i>&nbsp;&nbsp;&nbsp; */}
                                  <i className="fa fa-trash" style={{ cursor: "pointer" }} onClick={() => deleteHandler(row.original)}></i>
                                </td>
                                :
                                null
                              }
                              {canEdit ?
                                <td style={{ width: "5%" }}>
                                  <i className="fa fa-edit" style={{ cursor: "pointer" }} onClick={() => editHandler(row.values)}></i>&nbsp;&nbsp;&nbsp;
                                </td>
                                :
                                null
                              }
                              {canView ?
                                <td style={{ width: "5%" }}>
                                  <i className=" mdi mdi-eye-check" style={{ cursor: "pointer", fontSize: "18px" }} onClick={() => editHandler(row.values)}></i>&nbsp;&nbsp;&nbsp;
                                </td>
                                :
                                null}
                              {row}
                              {canImportView ?
                                <td style={{ width: "5%" }}>
                                  <i className=" mdi mdi-eye-check" style={{ cursor: "pointer", fontSize: "18px" }} onClick={() => editHandler(row.original)}></i>&nbsp;&nbsp;&nbsp;
                                </td>
                                :
                                null}
                            </tr > :
                            <tr>
                              {row.cells.map((cell: any) => {
                                const width = cell.column.width;
                                if (width === 0 || width === "0" || width === "0px" || width === "0%" || width === "0.0px") {
                                  return null;
                                }
                                return (
                                  <>
                                    <td key={cell.id} {...cell.getCellProps()} style={{ width: cell.column.width }}>
                                      {cell.column.input === true ?
                                        <CustomTextBox label={undefined} id={undefined} value={cell.value} error={undefined} />
                                        :
                                        cell.column.displayInList === false ? null : formatTableCell(cell.value, cell.column.datatype)
                                      }
                                      {cell.column.datatype === "link" ?
                                        <Link to={row.id} className="text-body fw-bold">{cell.value ? cell.value : ''}</Link> : null}
                                      {cell.column.datatype === "linkbtn" ?
                                        <span className="text-primary fw-bold cursor-pointer cell-underlined" onClick={() => linkBtnhandler(row.original)}>{cell.value ? cell.value : ''}</span> : null}
                                      {cell.column.type == "button" ?
                                        <Button type="button" color="primary" className="btn-sm btn-rounded mx-2 px-3">{cell.column.value}</Button> : null}

                                      {cell.column.datatype === "checkBox" ?
                                        <CustomCheckBox
                                          label={""}
                                          id={"checkBox"}
                                          // value={checkedIds.includes(row.original.id)}
                                          checked={checkIfChecked(row.original.id) ? false : true}
                                          error={undefined}
                                          onChange={(event) => handleCheckboxChange(event, row.original.id)} value={undefined} /> : null}
                                    </td>
                                  </>
                                );
                              })}
                              {isActionEdit ?
                                <td style={{ width: "5%" }}>
                                  <i className="fa fa-edit" style={{ cursor: "pointer" }} onClick={() => editHandler(row.original)}></i>&nbsp;&nbsp;&nbsp;
                                  {/* <i className="fa fa-trash" style={{ cursor: "pointer" }} onClick={() => deleteHandler(row.original)}></i> */}
                                </td>
                                :
                                null
                              }
                              {isActionDelete ?
                                <td style={{ width: "5%" }}>
                                  {/* <i className="fa fa-edit" style={{ cursor: "pointer" }} onClick={() => editHandler(row.original)}></i>&nbsp;&nbsp;&nbsp; */}
                                  <i className="fa fa-trash" style={{ cursor: "pointer" }} onClick={() => deleteHandler(row.original)}></i>
                                </td>
                                :
                                null
                              }
                              {canEdit ?
                                <td style={{ width: "5%" }}>
                                  <i className="fa fa-edit" style={{ cursor: "pointer" }} onClick={() => editHandler(row.values)}></i>&nbsp;&nbsp;&nbsp;
                                </td>
                                :
                                null
                              }
                              {canView ?
                                <td style={{ width: "5%" }}>
                                  <i className=" mdi mdi-eye-check" style={{ cursor: "pointer", fontSize: "18px" }} onClick={() => editHandler(row.values)}></i>&nbsp;&nbsp;&nbsp;
                                </td> : null}
                              {canImportView && row.original.IsImported &&
                                <td style={{ width: "5%" }}>
                                  <i className=" mdi mdi-eye-check" style={{ cursor: "pointer", fontSize: "18px" }} onClick={() => editHandler(row.original)}></i>&nbsp;&nbsp;&nbsp;
                                </td>}
                              {shareHandler ?
                                <td style={{ width: "5%" }}>
                                  <i className="fa fa-edit" style={{ cursor: "pointer" }} onClick={() => editHandler(row.original)}></i>&nbsp;&nbsp;&nbsp;
                                  <i className="fa fa-trash" style={{ cursor: "pointer" }} onClick={() => deleteHandler(row.original)}></i>&nbsp;&nbsp;&nbsp;
                                  {/* <i className="fa fa-share" style={{ cursor: "pointer",  }} onClick={() => shareHandler(row.values)}></i> */}
                                </td> : null}
                            </tr >
                          }
                        </Fragment>
                      );
                    })}
                  </tbody>
                </>

              ))}
            </Table>
          </div>
          {isPagination && (
            <Paginate recordsCount={recordsCount} rowName={rowName} rowsPerPage={rowsPerPage} currentPage={currentPage} setCurrentPage={setCurrentPage} offsetStart={offsetStart} setOffsetStart={setOffsetStart} />
          )}
        </> :
        <Row>
          <Col xl={12} className='text-center'>
            <div className="m-4">
              <i className="bx bx-folder-open font-size-24"></i>
              <h6 className='m-2 text-dofy fw-semibold '>No Records Found</h6>
            </div>
          </Col>
        </Row>}
    </Fragment>
  );
};
export default CustomDataTable;
